import { graphql } from "@/lib/gql/__generated__/gql";

export const PlanUpdateMutation = graphql(/* GraphQL */ `
	mutation PlanUpdate($input: PlanInput!, $planCustomMailSettingInput: PlanCustomMailSettingInput!) {
		planUpdate(input: $input) {
			userErrors
			plan {
				id
				hotelID
				planID
				inSale
				isPrivate
				isRequest
				isDayTrip
				isReservedAtLeastOnce
				name
				mainTarget
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				availableRoomIDs
				availableOptionIDs
				requiredOptionIDs
				requiredOptionGroupIDs
				defaultDiscountID
				availableDiscountIDs
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				checkInStart
				checkInEnd
				checkOut
				longStayParams {
					minimumStayDates
				}
				shortStayParams {
					maximumStayDates
				}
				isUncancelable
				isUnchangeable
				isChangeOnlyOption
				roomChangeDisable
				maxRoomNum
				minRoomNum
				minimumPeopleNumPerRoom
				maxPeopleNumPerRoom
				notSendCinMail
				emailTemplateReservation {
					atCreated
					atUpdated
					atCanceled
					atCin
				}
				isNoAddressNeeded
				isShowRoomForGuest
				includedMeals
				questions {
					questionID
					required
					questionType
					question
					options
				}
				isHiddenHotelQuestions
				onlyUseLocalPayment
				onlyUseCreditPayment
				saleTypeForTerm
				saleStart
				saleEnd
				saleStartTime
				saleEndTime
				stayableStart
				stayableEnd
				stayableDayOfTheWeek
				isHolidayStayable
				checkInAvailableDayOfTheWeek
				isHolidayCheckInAvailable
				requiredPrepMillisecond
				saleStartBeforeDate
				maxStockNum
				soldNumTotal
				maxDailyStockNum
				stockTypeTerm
				stockTypeTarget
				doNotCountKidsAsStock
				billingTypeTerm
				billingTypeTarget
				price {
					currencyType
					amount
				}
				staticPriceParams {
					staticRoomPrices {
						roomID
						roomName
						prices {
							adultNum
						}
					}
				}
				isRoomPriceFree
				isCoSleepingKidsPriceActive
				coSleepingKidsPrice {
					currencyType
					amount
				}
			}
		}
		planCustomMailSettingUpdate(input: $planCustomMailSettingInput) {
			planCustomMailSetting {
				forReservation {
					atCreated {
						text
						override
					}
					atUpdated {
						text
						override
					}
					atCanceled {
						text
						override
					}
					atCheckInBefore_07days {
						text
						shouldSendEmail
						override
					}
					atCheckInBefore_01days {
						text
						shouldSendEmail
						override
					}
					atCheckInBefore_00days {
						text
						shouldSendEmail
						override
					}
					atCheckOutAfter_01days {
						text
						shouldSendEmail
						override
					}
				}
				id
				planID
			}
		}
	}
`);
